import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseSiteService, CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ContentService } from '../../spartacus/services/content.service';
declare const Calendly: any;
@Component({
    selector: 'app-banner-section-dashboard',
    templateUrl: './banner-section-dashboard.component.html',
    styleUrls: ['./banner-section-dashboard.component.scss'],
    standalone: false
})
export class BannerSectionDashboardComponent {
  currentSite: string | undefined;
  isAsAgent: boolean=false;
  showCalendly: boolean=false;
  constructor(public component: CmsComponentData<CmsBannerComponent>,
    public userInfoService: UserInfoService, private baseSiteService: BaseSiteService, private cdr: ChangeDetectorRef, protected config: OccConfig,public contentService:ContentService) {
  }
  bannerNode: Observable<any> = this.component.data$;
  //invoiceNode: Observable<any> = this.userInfoService.getInvoiceData();
  //orderData:Observable<any> = this.userInfoService.getOrdersDashboard();

  orderData: string = ''
  userData: any;
  calendlyData: any;
  invoiceNode: string = '';
  isCalendlyModalOpen:boolean =false;
  popupdata:any;

  ngOnInit() {
    this.isAsAgent = this.userInfoService.checkAsmUser();
    // this.contentService.getNavigation('calendlyPopUp').subscribe(res => {
    //   this.popupdata = res;
    // });
    localStorage.setItem('dashboarduk', 'true') 
    this.userInfoService.getUserData().subscribe(res => {
      this.userData = res;
    });
    this.baseSiteService.getActive().subscribe(res => {
      this.currentSite = res;
      if ( this.currentSite == 'seqirusb2b-uk') {
        this.contentService.getNavigation('calendlyPopUp')
          .subscribe(res => {
            this.popupdata = res;
          });
      }
    });
    this.userInfoService.getdashboardCount().subscribe(value => {
      if (value) {
        this.orderData = value
      } else {
        this.orderData = "0"
      }
      this.cdr.detectChanges();
    });
    this.userInfoService.getdashboardinvoiceCount().subscribe(value => {
      if (value) {
        this.invoiceNode = value
      } else {
        this.invoiceNode = "0"
      }
      this.cdr.detectChanges();
    });
    /* this.contentService.getCalendlyData().subscribe(value => {
      this.calendlyData = value;
      this.cdr.detectChanges();
    }) */
  }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.url;
  }
  ngAfterViewInit(): void {
    this.contentService.getCalendlyData().subscribe(value => {
      this.calendlyData = value;
      
      this.cdr.detectChanges();

      //let calendlyUrl = this.calendlyData.calendlyId;
      // if (calendlyUrl.indexOf('?') > -1) {
      //   calendlyUrl += '&hide_gdpr_banner=1';
      // } else {
      //   calendlyUrl += '?hide_gdpr_banner=1';
      // }
     // this.openCalendly();
      
    })
  }
  // openCalendly() {
  //  if (this.calendlyData) {
  //     //this.showCalendly = true;
  //     this.cdr.detectChanges();
  //     setTimeout(()=>{
  //     const container = document.getElementById('calendly-embed');
  //     if (container) {
  //       container.innerHTML=''
  //       Calendly.initInlineWidget({
  //         url: this.calendlyData.calendlyId,
  //         parentElement: container,
  //       });
  //     }
  //     },100)
     
  //   }
  // }
openCalendly() {
   if (this.isAsAgent) {
      return;
   }
  if (this.calendlyData) {
    this.isCalendlyModalOpen = true;
    document.body.style.overflowY = 'auto';
  }
}

openCalendlyUrl() {
  if (this.calendlyData?.calendlyId) {
    window.open(this.calendlyData.calendlyId, '_blank');
  }
  this.closeCalendlyModal();
}

closeCalendlyModal() {
  this.isCalendlyModalOpen = false;
  document.body.style.overflowY = 'auto';
}

  ngOnDestroy(){
    this.contentService.setCalendlyData(null);
  }
  
}
